import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.interior-form',
    method: 'get',
    params,
  })
}

export const listAllInterior = (params?: any) => {
  return axiosService({
    url: '/api.interior-form/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.interior-form/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.interior-form/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.interior-form/${id}`,
    method: 'put',
    data,
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.interior-form/${id}/reject`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.interior-form/${id}/remake`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any) => {
  return axiosService({
    url: `/api.interior-form/${id}/approve`,
    method: 'put',
    data: data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.interior-form/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.interior-form',
    method: 'post',
    data,
  })
}
